import { wincAppDomain } from '../../../../stacks/config';

/**
 * Check if we're running as the Winc app.
 * Checks both the build-time VITE_WINC_APP env var and the runtime hostname.
 */
export function isWincApp() {
  if (typeof window === 'undefined') return false;
  return !!(import.meta as any).env?.VITE_WINC_APP || location.host === wincAppDomain;
}
